import { ControllerLegado } from "app/types/ControllerLegado";
import { Permissao } from "app/types/Permissao";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { Dict } from "app/utils/Dict";
import React, { useEffect, useState } from "react";
import { AcompanhamentoContainer } from "../acompanhamento/AcompanhamentoContainer";
import { AtendimentoContainer } from "../atendimento/AtendimentoContainer";
import { CreditosClienteContainer } from "../creditos/CreditosClienteContainer";
import { DocumentosAbertosContainer } from "../documentos-abertos/DocumentosAbertosContainer";
import { FichaCrediarioContainer } from "../ficha-crediario-cliente/FichaCrediarioClienteContainer";
import { FichaFinanceiraClienteContainer } from "../ficha-financeira/FichaFinanceiraClienteContainer";
import { LimiteCreditoContainer } from "../limite-credito/LimiteCreditoContainer";
import { OrcamentoEmAbertosContainer } from "../orcamento-aberto/OrcamentoEmAbertoContainer";
import { DocumentoQuitadoContainer } from "../pesquisa-cliente/documentos-quitados/DocumentoQuitadoContainer";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { UltimasComprasContainer } from "../ultimas-compras/UltimasComprasContainer";
import { MenuConsultasCliente } from "./MenuConsultasCliente";
import { CashbackContainer } from "../cashback/CashbackContainer";
import { Parametro, ParametroPorItem } from "app/types/Parametro";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { useAppSelector } from "app/redux/hooks";
import globalMU from "globalMU";


export type MenuConsultasCliente = {
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover: () => boolean
    codigoCliente: number
    somenteLeitura?: boolean; // 430731
}


export type MenuConsultasClienteContainerProps = {
    onSelecionadoMenu: () => void;
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    pesquisarClientesController: ControllerLegado
    possuiCashback: boolean
    possuiCredito: boolean,
    possuiAtendimento: boolean,
    possuiAcompanhamento: boolean
    codigoCliente: number
    somenteLeitura?: boolean; // 430731
};

export const MenuConsultasClienteContainer = (props: MenuConsultasClienteContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento)
    const [permissoes, setPermissoes] = useState<Permissao[]>([])
    const [parametrosCarregados, setParametrosCarregados] = useState(false)
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]) // 433263

    const valorParametro = (nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor;

    const atualizarParametros = async () => {
        setParametrosPorFilial( // 433263
            await obterParametrosPorOidItem({
                nomes: ["PERCENTUAL_MAXIMO_CASHBACK_VENDA"],
                oidItem: orcamento.OidFilialOrcamento
            }))
    };

    const atualizarPermissoes = async () => {
        setPermissoes([
            {
                Funcionalidade: "ORCAMENTO_ATENDIMENTO_CLIENTES",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_ATENDIMENTO_CLIENTES" })
            },
            {
                Acao: "FICHA_CREDIARIO_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "FICHA_CREDIARIO_CLIENTE" })
            },
            {
                Acao: "FICHA_FINANCEIRA_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "FICHA_FINANCEIRA_CLIENTE" })
            },
            {
                Acao: "DOCUMENTOS_ABERTO_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "DOCUMENTOS_ABERTO_CLIENTE" })
            },
            {
                Acao: "CREDITOS_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "CREDITOS_CLIENTE" })
            },
            {
                Acao: "ORCAMENTO_ABERTO_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_ABERTO_CLIENTE" })
            },
            {
                Acao: "LIMITE_CREDITO_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "LIMITE_CREDITO_CLIENTE" })
            },
            {
                Acao: "ACOMPANHAMENTO_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ACOMPANHAMENTO_CLIENTE" })
            },
            {
                Acao: "ULTIMAS_COMPRAS_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ULTIMAS_COMPRAS_CLIENTE" })
            },
            {
                Acao: "DOCUMENTOS_QUITADOS_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "DOCUMENTOS_QUITADOS_CLIENTE" })
            },
            {
                Acao: "CASHBACK_CLIENTE",
                Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "CASHBACK_CLIENTE" })
            },
        ])
        setParametrosCarregados(true)
    }


    const propsBase: MenuConsultasCliente = {
        onRemover: () => removerComponenteReact("conteudo-pagina"),
        onVoltar: () => props.onVoltar(),
        passos: props.passos,
        somenteLeitura: props.somenteLeitura, //430731
        codigoCliente: props.codigoCliente
    }

    const onRenderizarAtendimento = () => {
        renderizarComponentReact(<AtendimentoContainer regiaoRenderizada="conteudo-pagina" {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarDocumentosEmAberto = () => {
        renderizarComponentReact(<DocumentosAbertosContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarFichaCrediario = () => {
        renderizarComponentReact(<FichaCrediarioContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarFichaFinanceira = () => {
        renderizarComponentReact(<FichaFinanceiraClienteContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarCreditos = () => {
        renderizarComponentReact(<CreditosClienteContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarOrcamentoEmAberto = () => {
        renderizarComponentReact(<OrcamentoEmAbertosContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarLimiteDeCredito = () => {
        renderizarComponentReact(<LimiteCreditoContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarAcompanhamento = () => {
        renderizarComponentReact(<AcompanhamentoContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarDocumentosQuitados = () => {
        renderizarComponentReact(<DocumentoQuitadoContainer {...propsBase} />, "conteudo-pagina", true);
    }

    const onRenderizarUltimasCompras = () => {
        renderizarComponentReact(<UltimasComprasContainer {...propsBase} pesquisarClientesController={props.pesquisarClientesController} />, "conteudo-pagina", true);
    }

    const onRenderizarCashback = () => {
        renderizarComponentReact(<CashbackContainer {...propsBase} />, "conteudo-pagina", true);
    }


    useEffect(() => {
        atualizarPermissoes()
        atualizarParametros()
    }, [])


    return (
        <>
            {parametrosCarregados &&
                <MenuConsultasCliente
                    possuiAcompanhamento={props.possuiAcompanhamento}
                    possuiAtendimento={props.possuiAtendimento}
                    possuiCredito={props.possuiCredito}
                    possuiCashback={props.possuiCashback}
                    permitirVisualizarAtendimento={permissoes?.find((permissao) => permissao.Funcionalidade == "ORCAMENTO_ATENDIMENTO_CLIENTES")?.Permitido}
                    permitirVisualizarFichaCrediario={permissoes?.find((permissao) => permissao.Acao == "FICHA_CREDIARIO_CLIENTE")?.Permitido}
                    permitirVisualizarFichaFinanceira={permissoes?.find((permissao) => permissao.Acao == "FICHA_FINANCEIRA_CLIENTE")?.Permitido}
                    permitirVisualizarDocumentosEmAberto={permissoes?.find((permissao) => permissao.Acao == "DOCUMENTOS_ABERTO_CLIENTE")?.Permitido}
                    permitirVisualizarCreditos={permissoes?.find((permissao) => permissao.Acao == "CREDITOS_CLIENTE")?.Permitido}
                    permitirVisualizarOrcamentoEmAberto={permissoes?.find((permissao) => permissao.Acao == "ORCAMENTO_ABERTO_CLIENTE")?.Permitido}
                    permitirVisualizarLimiteDeCredito={permissoes?.find((permissao) => permissao.Acao == "LIMITE_CREDITO_CLIENTE")?.Permitido}
                    permitirVisualizarAcompanhamento={permissoes?.find((permissao) => permissao.Acao == "ACOMPANHAMENTO_CLIENTE")?.Permitido}
                    permitirVisualizarUltimasCompras={permissoes?.find((permissao) => permissao.Acao == "ULTIMAS_COMPRAS_CLIENTE")?.Permitido}
                    permitirVisualizarDocumentosQuitados={permissoes?.find((permissao) => permissao.Acao == "DOCUMENTOS_QUITADOS_CLIENTE")?.Permitido}
                    permitirVisualizarCashback={permissoes?.find((permissao) => permissao.Acao == "CASHBACK_CLIENTE")?.Permitido && parseFloat(globalMU.unformatNumber(valorParametro("PERCENTUAL_MAXIMO_CASHBACK_VENDA"))) > 0} 
                    onRenderizarCashback={onRenderizarCashback}
                    onRenderizarAtendimento={onRenderizarAtendimento}
                    onRenderizarFichaCrediario={onRenderizarFichaCrediario}
                    onRenderizarFichaFinanceira={onRenderizarFichaFinanceira}
                    onRenderizarDocumentosEmAberto={onRenderizarDocumentosEmAberto}
                    onRenderizarCreditos={onRenderizarCreditos}
                    onRenderizarOrcamentoEmAberto={onRenderizarOrcamentoEmAberto}
                    onRenderizarLimiteDeCredito={onRenderizarLimiteDeCredito}
                    onRenderizarAcompanhamento={onRenderizarAcompanhamento}
                    onRenderizarUltimasCompras={onRenderizarUltimasCompras}
                    onRenderizarDocumentosQuitados={onRenderizarDocumentosQuitados}
                    onSelecionadoMenu={props.onSelecionadoMenu}
                />
            }
        </>
    )
}